import api from './BaseApi';

export const getDashboard = async () => {
    try {
        const response = await api.get('/admin/dashboard');
        return response.data;
    } catch (error) {
        console.error('Get Dashboard error:', error);
        throw error;
    }
};

// Sidebar count ke liye same dashboard API use kar rahe hain (404 avoid karne ke liye)
export const getSidebarCount = async () => {
    try {
        const response = await api.get('/admin/dashboard');
        return response.data;
    } catch (error) {
        console.error('Get Sidebar Count error:', error);
        throw error;
    }
};